<template>
  <div class="client-layout">
    <!-- Banner区域 -->
    <div class="banner-container" v-if="currentBanner">
      <el-carousel
        :height="bannerHeight"
        :interval="5000"
        arrow="hover"
        :autoplay="true"
      >
        <el-carousel-item v-for="banner in [currentBanner]" :key="banner.id">
          <div class="banner-item">
            <img
              :src="imgUrl(banner.banner)"
              :alt="banner.title"
              class="banner-image"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- 移动端banner右下角语言切换和用户菜单 -->
      <div class="mobile-controls">
        <div class="mobile-lang-switch">
          <el-radio-group
            v-model="currentLanguage"
            size="small"
            @change="handleLanguageChange"
          >
            <el-radio-button label="simplified">简体</el-radio-button>
            <el-radio-button label="traditional">繁體</el-radio-button>
          </el-radio-group>
        </div>

        <!-- 移动端用户菜单 -->
        <div class="mobile-user-menu">
          <!-- 未登录状态 -->
          <template v-if="!authStore.isAuthenticated()">
            <el-button
              type="primary"
              size="small"
              class="login-btn"
              @click="$router.push('/login')"
            >
              登录
            </el-button>
          </template>

          <!-- 已登录状态 -->
          <template v-else>
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="user-info">
                <el-avatar
                  :size="32"
                  :src="
                    authStore.user?.avatar
                      ? imgUrl(authStore.user.avatar)
                      : defaultAvatar
                  "
                />
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="profile">
                    <el-icon><User /></el-icon>个人中心
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="authStore.user?.is_superuser"
                    command="admin"
                    divided
                  >
                    <el-icon><Management /></el-icon>后台管理
                  </el-dropdown-item>
                  <el-dropdown-item command="logout" divided>
                    <el-icon><SwitchButton /></el-icon>退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </div>
      </div>
    </div>

    <!-- 导航栏 -->
    <nav class="nav-container">
      <div class="nav-content">
        <!-- PC端菜单 -->
        <div class="nav-menu">
          <template v-for="menu in menus" :key="menu.id">
            <!-- 一级菜单 -->
            <div
              class="menu-item"
              :class="{
                'has-children': menu.children?.length,
                active: isActive(menu.link),
              }"
              @mouseenter="handleMouseEnter(menu)"
              @mouseleave="handleMouseLeave(menu)"
            >
              <router-link :to="menu.link" class="menu-link">
                {{ menu.title }}
              </router-link>

              <!-- 二级菜单 -->
              <div
                v-if="menu.children?.length"
                class="submenu"
                :class="{ 'submenu-open': menu.isOpen }"
              >
                <router-link
                  v-for="child in menu.children"
                  :key="child.id"
                  :to="child.link"
                  class="submenu-item"
                  :class="{ active: isActive(child.link) }"
                >
                  {{ child.title }}
                </router-link>
              </div>
            </div>
          </template>

          <!-- 语言切换菜单项 -->
          <div class="menu-item lang-menu-item">
            <div class="menu-link">
              <el-radio-group
                v-model="currentLanguage"
                size="small"
                @change="handleLanguageChange"
              >
                <el-radio-button label="simplified">简体</el-radio-button>
                <el-radio-button label="traditional">繁體</el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <!-- 用户相关菜单项 -->
          <div class="menu-item user-menu-item">
            <!-- 未登录状态 -->
            <template v-if="!authStore.isAuthenticated()">
              <el-button
                type="primary"
                size="small"
                class="login-btn"
                @click="$router.push('/login')"
              >
                登录
              </el-button>
            </template>

            <!-- 已登录状态 -->
            <template v-else>
              <el-dropdown trigger="click" @command="handleCommand">
                <div class="user-info">
                  <el-avatar
                    :size="32"
                    :src="
                      authStore.user?.avatar
                        ? imgUrl(authStore.user.avatar)
                        : defaultAvatar
                    "
                  />
                  <span class="username">{{ authStore.user?.username }}</span>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <!-- <el-dropdown-item command="profile">
                      <el-icon><User /></el-icon>个人中心
                    </el-dropdown-item> -->
                    <el-dropdown-item
                      v-if="authStore.user?.is_superuser"
                      command="admin"
                      divided
                    >
                      <el-icon><Management /></el-icon>后台管理
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided>
                      <el-icon><SwitchButton /></el-icon>退出登录
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
          </div>
        </div>
      </div>
    </nav>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
        <!-- <div class="footer-section">
          <h3>关于我们</h3>
          <p>这里是关于我们的简介，可以添加一些简短的描述文字。</p>
        </div> -->
        <div class="footer-section">
          <h3>联系方式</h3>
          <ul>
            <!-- <li>
              <el-icon><Location /></el-icon>
              地址：您的地址
            </li> -->
            <li>
              <el-icon><Phone /></el-icon>
              电话：18569547153
            </li>
            <li>
              <el-icon><Message /></el-icon>
              邮箱：1138840832@qq.com
            </li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <ul>
            <li v-for="menu in quickLinks" :key="menu.id">
              <router-link :to="menu.link">{{ menu.title }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="footer-bottom">
        <p>
          &copy; {{ new Date().getFullYear() }} 您的网站名称. All rights
          reserved.
        </p>
      </div> -->
    </footer>

    <!-- 返回顶部按钮 -->
    <el-backtop :right="20" :bottom="20" />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  Menu,
  Close,
  Location,
  Phone,
  Message,
  User,
  Setting,
  Management,
  SwitchButton,
} from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { menuApi } from "@/api/navigates";
import { useLangStore } from "@/stores/lang";
import { useAuthStore } from "@/stores/auth";
import defaultAvatar from "@/assets/default-avatar.png";

const langStore = useLangStore();
const route = useRoute();
const router = useRouter();
const menus = ref([]);
const quickLinks = ref([]);
const currentLanguage = ref(langStore.currentLang);
const authStore = useAuthStore();

// 响应式banner高度
const bannerHeight = computed(() => {
  if (window.innerWidth <= 768) {
    return "200px";
  } else if (window.innerWidth <= 1024) {
    return "440px";
  }
  return "780px";
});

// 获取当前路由对应的banner
const currentBanner = computed(() => {
  const currentPath = route.path;
  return findBannerByPath(currentPath);
});

// 根据路径查找banner
const findBannerByPath = (path) => {
  const traverse = (items) => {
    for (const item of items) {
      if (item.link === path && item.banner) {
        return item;
      }
      if (item.children?.length) {
        const found = traverse(item.children);
        if (found) return found;
      }
    }
    return null;
  };
  return traverse(menus.value);
};

// 判断菜单是否激活
const isActive = (link) => {
  return route.path === link;
};

// 处理菜单展开
const handleMouseEnter = (menu) => {
  if (window.innerWidth > 768) {
    menu.isOpen = true;
  }
};

const handleMouseLeave = (menu) => {
  if (window.innerWidth > 768) {
    menu.isOpen = false;
  }
};

// 获取菜单数据
const fetchMenus = async () => {
  try {
    const res = await menuApi.getMenuTree();
    menus.value = res.data;
  } catch (error) {
    console.error("获取菜单失败:", error);
  }
};

// 获取快速链接
const fetchQuickLinks = async () => {
  try {
    const res = await menuApi.getMenus({ is_active: true });
    quickLinks.value = res.data.results.slice(0, 5);
  } catch (error) {
    console.error("获取快速链接失败:", error);
  }
};

// 获取图片url
const imgUrl = (url) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return process.env.VUE_APP_API_URL + url;
};

const handleLanguageChange = () => {
  langStore.switchLang(currentLanguage.value);
};

// 处理用户下拉菜单命令
const handleCommand = (command) => {
  switch (command) {
    case "profile":
      router.push("/profile");
      break;
    case "admin":
      window.open("/admin", "_blank");
      break;
    case "logout":
      authStore.clearUserInfo();
      router.push("/");
      ElMessage.success("退出登录成功");
      break;
  }
};

onMounted(() => {
  fetchMenus();
  fetchQuickLinks();
});

onUnmounted(() => {
});
</script>

<style scoped lang="scss">
.client-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
  .banner-container {
    width: 100%;
    position: relative;
    z-index: 1;

  :deep(.el-carousel__container) {
    border-radius: 0;
  }

  .banner-item {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      z-index: 1;
      width: 80%;
      max-width: 800px;

      h2 {
        font-size: 2.5rem;
        margin-bottom: 1.5rem;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.3);
    }
  }

  // 移动端控制区域（语言切换和用户菜单）
  .mobile-controls {
    transform: scale(0.7);
    display: none;
    position: absolute;
    right: -10px;
    bottom: 0px;
    z-index: 10;
    gap: 8px;
    align-items: center;

    .mobile-lang-switch {
      :deep(.el-radio-group) {
        display: flex;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border-radius: 24px;
        padding: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      :deep(.el-radio-button) {
        &:first-child .el-radio-button__inner {
          border-radius: 20px 0 0 20px;
        }

        &:last-child .el-radio-button__inner {
          border-radius: 0 20px 20px 0;
        }

        .el-radio-button__inner {
          border: none;
          background: transparent;
          padding: 6px 16px;
          height: 32px;
          line-height: 20px;
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease;
          box-shadow: none !important;

          &:hover {
            color: var(--el-color-primary);
          }
        }

        &.is-active .el-radio-button__inner {
          background: linear-gradient(135deg, #9dc5eb 0%, #9288ee 100%);
          color: #fff;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          font-weight: 500;
          box-shadow: none !important;
        }
      }
    }

    .mobile-user-menu {
      .login-btn {
        height: 32px;
        padding: 20px 20px;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-radius: 24px;
        color: #666;
        transition: all 0.3s ease;

        &:hover {
          color: #fff;
          background: linear-gradient(135deg, #9dc5eb 0%, #9288ee 100%);
          border-color: transparent;
        }
      }

      .user-info {
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border-radius: 50%;
        padding: 4px;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease;

        &:hover {
          background: rgba(255, 255, 255, 1);
          transform: scale(1.05);
        }

        .el-avatar {
          display: block;
        }
      }

      :deep(.el-dropdown-menu) {
        transform: scale(0.95);
        transform-origin: top right;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }
}

.nav-container {
  background: #f4ded1;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  border-bottom: 1px solid var(--el-border-color-light);

  .nav-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    min-height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .nav-menu {
    display: flex;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px 0;

    .menu-item {
      position: relative;
      padding: 0 15px;

      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 17px;
        background-color: rgba(0, 0, 0, 0.2);
      }

      &.lang-menu-item {
        :deep(.el-radio-group) {
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 24px;
          padding: 4px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        :deep(.el-radio-button) {
          margin: 0;

          &:first-child .el-radio-button__inner {
            border-radius: 20px 0 0 20px;
          }

          &:last-child .el-radio-button__inner {
            border-radius: 0 20px 20px 0;
          }

          .el-radio-button__inner {
            border: none;
            background: transparent;
            padding: 8px 16px;
            height: 32px;
            line-height: 16px;
            font-size: 14px;
            color: #666;
            transition: all 0.3s ease;
            box-shadow: none !important;

            &:hover {
              color: var(--el-color-primary);
            }
          }

          &.is-active .el-radio-button__inner {
            background: linear-gradient(135deg, #9dc5eb 0%, #9288ee 100%);
            color: #fff;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            font-weight: 500;
            box-shadow: none !important;
          }
        }
      }

      .menu-link {
        padding: 8px 0;
        color: var(--el-text-color-primary);
        text-decoration: none;
        font-size: 16px;
        white-space: nowrap;
        position: relative;

        &:hover {
          color: var(--el-color-primary);
        }
      }

      &.active .menu-link {
        color: var(--el-color-primary);

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: var(--el-color-primary);
        }
      }

      &.has-children {
        .menu-link {
          padding-right: 20px;

          &::before {
            content: "";
            position: absolute;
            right: 0;
            top: 50%;
            width: 6px;
            height: 6px;
            border: solid var(--el-text-color-primary);
            border-width: 0 1px 1px 0;
            transform: translateY(-70%) rotate(45deg);
            transition: all 0.3s ease;
          }
        }

        &:hover .menu-link::before {
          border-color: var(--el-color-primary);
          transform: translateY(-30%) rotate(-135deg);
        }
      }

      .submenu {
        position: absolute;
        top: 100%;
        left: 0;
        min-width: 200px;
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        opacity: 0;
        visibility: hidden;
        transform: translateY(10px);
        transition: all 0.3s ease;
        padding: 8px 0;
        z-index: 1001;

        &.submenu-open {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .submenu-item {
          display: block;
          padding: 8px 16px;
          color: var(--el-text-color-primary);
          text-decoration: none;
          transition: all 0.3s ease;

          &:hover {
            background: var(--el-color-primary-light-9);
            color: var(--el-color-primary);
          }

          &.active {
            color: var(--el-color-primary);
            background: var(--el-color-primary-light-9);
          }
        }
      }

      // 用户相关菜单项
      &.user-menu-item {
        margin-left: auto; // 将用户菜单推到最右边

        .login-btn {
          height: 32px;
          padding: 18px 20px;
          font-size: 14px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          border-radius: 24px;
          color: #666;
          transition: all 0.3s ease;

          &:hover {
            color: #fff;
            background: linear-gradient(135deg, #9dc5eb 0%, #9288ee 100%);
            border-color: transparent;
          }
        }

        .user-info {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          padding: 4px 8px;
          border-radius: 20px;
          transition: all 0.3s ease;

          &:hover {
            background: rgba(0, 0, 0, 0.05);
          }

          .username {
            font-size: 14px;
            color: var(--el-text-color-primary);
          }
        }

        :deep(.el-dropdown-menu) {
          padding: 4px 0;

          .el-dropdown-item {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 16px;
            font-size: 14px;

            .el-icon {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

.main-content {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.footer {
  background-color: #f5f7fa;
  padding: 60px 0 20px;
  margin-top: 40px;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;

    .footer-section {
      h3 {
        font-size: 18px;
        color: var(--el-text-color-primary);
        margin-bottom: 20px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -8px;
          width: 40px;
          height: 2px;
          background-color: var(--el-color-primary);
        }
      }

      p {
        color: var(--el-text-color-regular);
        line-height: 1.6;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 12px;
          color: var(--el-text-color-regular);
          display: flex;
          align-items: center;
          gap: 8px;

          .el-icon {
            color: var(--el-color-primary);
          }

          a {
            color: var(--el-text-color-regular);
            text-decoration: none;
            transition: color 0.3s ease;

            &:hover {
              color: var(--el-color-primary);
            }
          }
        }
      }
    }
  }

  .footer-bottom {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--el-border-color-light);
    text-align: center;

    p {
      color: var(--el-text-color-secondary);
      font-size: 14px;
    }
  }
}

// 响应式设计
@media screen and (max-width: 1024px) {
  .nav-container {
    .nav-content {
      max-width: 100%;
      padding: 0 15px;
    }

    .nav-menu {
      padding: 8px 0;

      .menu-item {
        padding: 0 12px;

        &:not(:last-child)::after {
          height: 15px;
        }

        .menu-link {
          font-size: 15px;
          padding: 6px 0;
        }

        &.has-children {
          .menu-link::before {
            width: 5px;
            height: 5px;
          }
        }

        .submenu {
          min-width: 180px;

          .submenu-item {
            padding: 6px 14px;
            font-size: 14px;
          }
        }
      }
    }
  }

  .banner-container {
    .banner-item {
      .banner-content {
        h2 {
          font-size: 2rem;
        }
      }
    }
  }

  .main-content {
    padding: 20px;
  }
}

@media screen and (max-width: 768px) {
  .nav-container {
    .nav-content {
      padding: 0 10px;
      flex-wrap: wrap;
      justify-content: center;

      .nav-menu {
        padding: 5px 0;
        width: 100%;
        justify-content: left;

        .menu-item {
          padding: 5px 10px;
          width: calc(100% / 3);
          text-align: center;

          &:not(:last-child)::after {
            display: none;
          }

          .menu-link {
            font-size: 14px;
            padding: 4px 0;

            &::before {
              display: none;
            }
          }

          &.has-children {
            .submenu {
              display: none;
            }
          }

          // 移动端语言切换样式
          &.lang-menu-item {
            display: none !important;
          }

          // 用户相关菜单项
          &.user-menu-item {
            display: none !important;
          }
        }
      }
    }
  }

  .banner-container {
    .banner-item {
      .banner-content {
        width: 90%;

        h2 {
          font-size: 1.25rem;
          margin-bottom: 0.75rem;
        }
      }
    }
    .mobile-controls {
      display: flex;
    }
  }

  .main-content {
    padding: 15px;
  }

  .footer {
    padding: 30px 0 15px;

    .footer-content {
      padding: 0 15px;
      gap: 25px;

      .footer-section {
        h3 {
          font-size: 16px;
          margin-bottom: 15px;
        }

        ul li {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }

    .footer-bottom {
      margin-top: 30px;
      padding-top: 15px;

      p {
        font-size: 12px;
      }
    }
  }
}
</style>
